export function isEmailValid(email) {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
}
export function enterFullScreen(){
    let elem = <any>document.documentElement;
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
}
export function IsPasswordStrong(password:string){
    let score = 1;
    if(password==null)
        return false;
    if(password.length<4)
        return false;
    if(password.length>=8)
        score++;
    if(password.length>=12)
        score++;
    if(/[0-9]+(\.[0-9][0-9]?)?/.test(password))
        score++;
    if(/^(?=.*[a-z])(?=.*[A-Z]).+$/.test(password))
        score++;
    if(/[!,@,#,$,%,^,&,*,?,_,~,-,£,(,)]/.test(password))
        score++;
    if(score<3)
        return false;
    else
        return true;
}

export function distinct<T>(items:T[]):T[]{
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    var unique = items.filter(onlyUnique);
    return unique;

}
export function SearchRecursive<T>(items:T[],childFinder:(element:T)=>T[],condition:(element:T)=>boolean):T{
    let q = [];
    q.push(...items);
    while(q.length>0){
        let element = q.shift();
        if(condition(element)){
            return element;
        }
        q.push(...childFinder(element));
    }
    return null;
}
export function SelectRecursive<T,TU>(parent:any,items:T[],sourceChildFinder:(element:T)=>T[],mapper:(element:T,parent:any)=>TU,destinationChildUpdater:(element:TU,children:TU[])=>void):TU[]{
    let result = items.map(x=>{
        let r = mapper(x,parent);
        let children = SelectRecursive(r,sourceChildFinder(x),sourceChildFinder,mapper,destinationChildUpdater)
        destinationChildUpdater(r,children);
        return r;
    });
    return result;

}
export function stringIsNullOrEmpty(s:string):boolean{
    if(s==null)
        return true;
    else if(s.trim()=='')
        return true;
    else
        return false;
}
export class UuidConverter{
    convertToBase8(uuid:string){
        let uuidWithoutDash = (uuid+'0').replace(/-/g,"");
        let parts = uuidWithoutDash.match(/.{1,3}/g);
        let b8 =(parts.map(x=>('0000'+parseInt(x,16).toString(8)).substr(-4))).join('');
        return b8;
    }
    ConvertFromBase8ToUUid(b8:string){
        let parts = b8.match(/.{1,4}/g);
        let uuidWithoutDash= parts.map(x=>('000'+parseInt(x,8).toString(16)).substr(-3)).join('').slice(0,-1);
        let uuid = uuidWithoutDash.slice(0,8)+"-"+uuidWithoutDash.slice(8,12)+"-"+uuidWithoutDash.slice(12,16)+"-"+uuidWithoutDash.slice(16,20)+"-"+uuidWithoutDash.slice(20);
        return uuid.toUpperCase();
    }
}

export class FileChooser{

    public maxsize : number;
    public async chooseFile():Promise<{
        filename:string,
        fileContent:string,
        isChoosed : boolean
    }>{
        let result = new Promise<{
            filename:string,
            fileContent:string,
            isChoosed : boolean
        }>((resolve,reject)=>{
            let input = document.createElement('input');
            input.type = 'file';
            input.onchange = e => { 
                let file = (<any>e).target.files[0]; 
                let size = file.size;
                if  (this.maxsize && this.maxsize>0 && size > this.maxsize * 1024)
                {
                    let txt = "لطفا حجم فایل انتخابی کمتر از " + this.maxsize + " کیلو بایت باشد.\n\n ";
                    alert(txt);
                    return;
                }
    
                let reader = new FileReader();
                reader.readAsDataURL(file); 
                reader.onabort = x=>{
                    resolve({
                        isChoosed : false,
                        fileContent : null,
                        filename : ''
                    });
                    document.removeChild(input);
                }
                reader.onerror = x=>{
                    resolve({
                        isChoosed : false,
                        fileContent : null,
                        filename : ''
                    });
                    document.removeChild(input);
                }
                reader.onload = readerEvent => {
                    let content =(<any> readerEvent.target.result).split(',')[1];
                    let fileName = file.name;
                    resolve({
                        isChoosed : true,
                        fileContent:content,
                        filename:fileName
                    });
                    document.removeChild(input);
                }
            }
            input.click(); 
        });

        return result;
    }
}

